import { render, staticRenderFns } from "./Activity2_3Order.vue?vue&type=template&id=c759a786&"
import script from "./Activity2_3Order.vue?vue&type=script&lang=js&"
export * from "./Activity2_3Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports